import { Box, Button, Divider, Paper, Typography } from "@mui/material";

const ListMenuItem = ({ item, order_input_func }) => {

  // const gdriveToDirect = (url) => {
  //   if (!url) return null;

  //   let fileId = null;

  //   // Format: /file/d/FILE_ID/
  //   const match = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
  //   if (match && match[1]) {
  //     fileId = match[1];
  //   }

  //   // Format: ?id=FILE_ID
  //   if (!fileId) {
  //     const params = new URL(url).searchParams;
  //     fileId = params.get("id");
  //   }

  //   if (!fileId) return null;

  //   return `https://lh3.googleusercontent.com/d/${fileId}`;
  // } 

  const gdriveToDirect = (url) => {
    if (!url) return null;

    let fileId = null;

    const match = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      fileId = match[1];
    }

    if (!fileId) {
      const params = new URL(url).searchParams;
      fileId = params.get("id");
    }

    if (!fileId) return null;
    
    return `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`;
  };


  const apiUrl = item.picture_link; 
  const imgSrc = gdriveToDirect(apiUrl);

  return (
    // <div>
      <Paper
        sx={{
          width: "100%",
          height: "100%",          
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 1.2,
          marginBottom: ".6em",
        }}
      >
        {item ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexGrow: 1,
              flexDirection: "row",
              alignItems: "stretch",
              justifyContent: "center",
              gap: 1,
              marginTop: 1
            }}
          >
            <Box
              sx={{
                flex: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                fontSize={{ xs: ".9em", sm: ".9em", md: "1em", lg: "1em" }}
                sx={{
                  fontWeight: 600,                                    
                  textTransform: "capitalize",
                }}                
              >
                {item.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: ".7em",
                  fontWeight: 400,
                  marginTop: ".3em",
                }}
              >
                {item.desc}
              </Typography>

              <Typography
                fontSize={{ xs: ".9em", sm: ".9em", md: "1em", lg: "1em" }}
                sx={{
                  fontWeight: 700,
                  marginTop: ".4em",
                }}
              >
                {new Intl.NumberFormat("id-ID", {
                  style: "currency",
                  currency: "IDR",
                  minimumFractionDigits: 0,
                }).format(item.price)}
              </Typography>
            </Box>
            <Box
              maxHeight={100}
              maxWidth={100}
              sx={{
                flex: 1,
                backgroundColor: "aliceblue",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                objectFit: "inherit",
                overflow: "hidden",
                borderRadius: 4,
              }}
            >
              <img                
                src={imgSrc}
                alt="menu"
                width="100px"
                height="100px"
                loading="lazy"
              />
            </Box>
          </Box>
        ) : (
          <Box>Loading . . </Box>
        )}

        {/* Tombol untuk tambah pesanan */}        
        <Divider
          width="100%"
          height="2px"
          sx={{
            marginTop: ".4em",
            marginbottom: ".4em",
          }}
        />
        <Box>
          <Button
            variant="outlined"
            sx={{
              fontSize: ".65em",
              borderRadius: 8,
              marginTop: "1em",
              marginBottom: ".4em",
            }}
            onClick={() => order_input_func(item)}
          >
            tambah
          </Button>
        </Box>
      </Paper>
    // {/* </div> */}
  );
};

export default ListMenuItem;
